module.exports = __webpack_public_path__ + "img/2_3_1.bdb7507a.jpg";